import cx from "classnames";

export function EntryButton({
  theme,
  className,
  ...props
}: { theme: "green" | "red" } & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      {...props}
      className={cx(
        "inline-flex items-center justify-center rounded-4 border-none p-2 opacity-70",
        "disabled:cursor-not-allowed disabled:bg-gray-neutral disabled:text-gray-lighter",
        !props.disabled && "hover:opacity-100 disabled:hover:opacity-70",
        !props.disabled &&
          (theme === "green" ? "bg-green-500/15 text-primary-alpha-darker" : "bg-red-alpha-16 text-red-alpha-100"),
        className
      )}
    />
  );
}
